import typography from "../../typography";

export default {
  root: {
  
  },
  wrapped: {
    fontSize: "16px",
    fontWeight: typography.fontWeightMedium
  }
};